import { Injectable } from '@angular/core';
import { Tarif } from '../models/tarif';

const tarifs: Tarif[] = [
  {
    natureService: 'Liste de ventes / 1 type de bien / maximum 30 références',
    nbreCredit: 12,
  },
  {
    natureService: 'Évaluation manuelle + Liste de ventes',
    nbreCredit: 18,
  },
  {
    natureService: 'Evaluation automatique',
    nbreCredit: 18,
  },
  {
    natureService: 'Actualisation de la valeur',
    nbreCredit: 6,
  },
  {
    natureService: 'Rapport Perval',
    nbreCredit: 8,
  },
  {
    natureService: "Liste d'avant-contrats",
    nbreCredit: 12,
  },
];

@Injectable({
  providedIn: 'root',
})
export class GrilleTarifaireService {
  async getGrilleTarifaireServices(): Promise<Tarif[]> {
    return Promise.resolve(tarifs);
  }
}
